import React from "react"
import MyDateDayMonthYearFormField from "@common-components/fields/MyDateDayMonthYearFormField"
import MySelectFormField from "@common-components/fields/MySelectFormField"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM, CONST_PERSONNEL_NDF_DETAILS_CATEGORIES_OPTIONS_FOR_SELECT2 } from "@common-constants/*"

export const NdfBasicFieldsSection = ({ helpers, validationSchema }: any) => {
     const isKM = helpers.values.categorie === CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM

     return (
          <>
               <MySelectFormField
                    formikProps={helpers}
                    validationSchema={validationSchema}
                    options={CONST_PERSONNEL_NDF_DETAILS_CATEGORIES_OPTIONS_FOR_SELECT2}
                    name={"categorie"}
                    isSearchable={false}
                    placeholder={"Sélectionnez la catégorie en premier..."}
                    label={"Catégorie"}
                    classNameLabel={"col-lg-4"}
                    classNameField={"col-lg-8"}
               />

               {helpers.values.categorie && !isKM && (
                    <MyDateDayMonthYearFormField
                         name={"date"}
                         formikProps={helpers}
                         validationSchema={validationSchema}
                         placeholder={"Date"}
                         label={<span className={"required"}>Date</span>}
                         classNameLabel={"col-lg-4"}
                         classNameField={"col-lg-8"}
                    />
               )}
          </>
     )
}
